// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"CutCosts_TheComp__i0x_e"};